import { AxiosError } from "axios";
import { useAppSelector } from "../../app/hooks";
import { UserType } from "../../types";
import { selectUser } from "./userSlice";

/*
 Se l'utenza, sull'azienda della sessione, è in sola lettura: l'abbonamento dell'azienda è stato
 disattivato nel calendario (ODOO 300). Si consulta e si scaricano gli attestati, ma non si
 modifica nessun dato e non si prenota.

 A decidere è il backend, che rifiuta ogni modifica con un 403 (`SolaLetturaInterceptor`) e
 manda lo stato in `solaLettura` con login, scelta dell'azienda e rinnovo del token, ruolo già
 considerato: un SUPERADMIN non è mai in sola lettura. Qui serve solo a non mostrare comandi che
 il backend rifiuterebbe. Un valore assente vale falso: è la risposta di un backend di prima.
*/
export function inSolaLettura(
  utente: Pick<UserType, "solaLettura"> | undefined | null
): boolean {
  return utente?.solaLettura === true;
}

export function useSolaLettura(): boolean {
  return inSolaLettura(useAppSelector(selectUser));
}

/*
 Il messaggio da mostrare per un errore di una chiamata di modifica: se il backend ha rifiutato
 con 403 e un messaggio (la sola lettura, o un ruolo che non può), quello; altrimenti il
 ripiego del chiamante. Serve dove il frontend non sa ancora di essere in sola lettura, per
 esempio quando l'abbonamento è stato disattivato a sessione aperta.
*/
export function messaggioDiRifiuto(errore: unknown, ripiego: string): string {
  const risposta = (errore as AxiosError<{ message?: unknown }>)?.response;
  const messaggio = risposta?.data?.message;
  if (risposta?.status === 403 && typeof messaggio === "string" && messaggio) {
    return messaggio;
  }
  return ripiego;
}
